import { Link } from "react-router-dom";
import { money } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

export default function ProductCard({ p, symbol = "Rs." }) {
  const img = (p.images && p.images[0]) || "https://images.unsplash.com/photo-1526406915894-7bcd65f60845";
  return (
    <Link
      to={`/products/${p.id}`}
      data-testid={`product-card-${p.id}`}
      className="group flex flex-col overflow-hidden rounded-xl border border-border bg-card transition-all hover:-translate-y-1 hover:border-primary/50 hover:shadow-lg"
    >
      <div className="relative aspect-square overflow-hidden bg-secondary">
        <img src={img} alt={p.name} loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        {p.is_featured && <Badge className="absolute left-3 top-3 bg-primary text-primary-foreground">Featured</Badge>}
        {p.stock === 0 && <Badge className="absolute right-3 top-3" variant="secondary">Out of Stock</Badge>}
      </div>
      <div className="flex flex-1 flex-col p-4">
        <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{p.brand}</span>
        <h3 className="mt-1 line-clamp-2 font-display text-base font-semibold leading-snug">{p.name}</h3>
        <div className="mt-auto pt-3">
          <p className="text-lg font-bold text-primary">{money(p.installment_price, symbol)}</p>
          <p className="text-xs text-muted-foreground line-through">{money(p.cash_price, symbol)} cash</p>
          <span className="mt-2 inline-block rounded-full bg-accent px-2.5 py-1 text-xs font-semibold text-accent-foreground">On Installments</span>
        </div>
      </div>
    </Link>
  );
}
